export default __webpack_public_path__ + "static/media/iconDownload.54c1beff.svg";